import { ResultadoBusca } from './../../common/types/Busca'

const KEY = 'buscasRecentes'
export const buscasRecentes: ResultadoBusca[] = localStorage[KEY]
	? JSON.parse(localStorage[KEY])
	: []

export function adicionarBuscaRecente(item: ResultadoBusca) {
	const indice = buscasRecentes.findIndex(({ _id }) => _id === item._id , item)
	if (indice !== -1) { buscasRecentes.splice(indice, 1) }

	buscasRecentes.unshift(item)
	localStorage.setItem(KEY, JSON.stringify(buscasRecentes))
}
